module.exports = __webpack_public_path__ + "static/assets/e7f8d80ae1884fb1f527ed8ecaefe1ea.svg";